import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { SharedModule } from 'src/app/shared/shared.module';
import { ErrorLogsFiltersComponent } from './components/errorlogs-filters.component';
import { ErrorlogsTableComponent } from './components/errorlogs-table/errorlogs-table.component';
import { MessageDialogComponent } from './components/message-dialog.component';
import { PropertyDialogComponent } from './components/property-dialog.component';
import { ErrorlogsComponent } from './errorlogs.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CalendarModule,
    ButtonModule,
    SelectButtonModule,
    DropdownModule,
    TableModule,
    SharedModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    DialogModule
  ],
  declarations: [
    ErrorlogsComponent,
    ErrorlogsTableComponent,
    ErrorLogsFiltersComponent,
    PropertyDialogComponent,
    MessageDialogComponent
  ]
})
export class ErrorlogsModule { }
